import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
window.REACT_APP_ABANINJA_API_KEY = process.env.REACT_APP_ABANINJA_API_KEY
window.REACT_APP_ABANINJA_ACCOUNT_UUID = process.env.REACT_APP_ABANINJA_ACCOUNT_UUID

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
